import React from 'react';
import { OEConnectEnvironment } from '../../../infrastructure/runtime-configuration';
import './account-subdomain-input.scss';

interface IProps {
    value: string;
    onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
}

const AccountSubdomainInput = (props: IProps) => {
    const prefix = 'https://';
    const postfix = 'open-exchange.net/';

    const getPostfix = (): string => {
        // @ts-ignore
        switch (window.OEConnectConfig.env) {
            case OEConnectEnvironment.Prod:
                return '.' + postfix;
            case OEConnectEnvironment.Stage:
                return '.stage-' + postfix;
            default:
                return '.dev-' + postfix;
        }
    };

    return (
        <div className={`account-subdomain-input-wrapper ${props.className}`} >
            <div className='account-subdomain-input w-100'>
                <span className='account-subdomain-input__prefix'>{prefix}</span>
                <input
                    value={props.value || ''}
                    className='oe-form-field__control'
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    onKeyPress={e => (e.key === 'Enter' ? e.preventDefault() : null)}
                />
                <span className='account-subdomain-input__prefix'>{getPostfix()}</span>
            </div>
        </div>
    );
};

export default AccountSubdomainInput;
